import { type ReactElement, Suspense } from "react";
import { QueryParamProvider } from "use-query-params";
import "./styles/chakra-customizations.css";
import { Provider } from "@agrigate/shared-web-ui/lib/components/ui/provider";
import ReactRouterAdapter from "@agrigate/shared-web-ui/lib/utils/qparams-react-router-adapter";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "./components/ErrorBoundaryFallback";
import LoginGuard from "./components/LoginGuard";
import AdminLayout from "./layout/AdminLayout";
import "./utils/posthog";

function App(): ReactElement {
    return (
        <Provider>
            <QueryParamProvider adapter={ReactRouterAdapter}>
                <Suspense fallback={<p>Loading...</p>}>
                    <ErrorBoundary
                        fallback={<ErrorBoundaryFallback />}
                        onError={error => {
                            console.error("Boundary error: ", error);
                        }}
                    >
                        <LoginGuard>
                            <AdminLayout />
                        </LoginGuard>
                    </ErrorBoundary>
                </Suspense>
            </QueryParamProvider>
        </Provider>
    );
}

export default App;
